import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Result, Button } from 'antd'
import { useAuthStore } from '../../stores/authStore'

interface RouteGuardProps {
  children: React.ReactNode
  requiredRoles?: string[]
}

const RouteGuard: React.FC<RouteGuardProps> = ({ children, requiredRoles }) => {
  const { user, checkRouteAccess } = useAuthStore()
  const location = useLocation()

  // 未登录，重定向到登录页
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // 检查路由访问权限
  if (!checkRouteAccess(location.pathname)) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="抱歉，您没有权限访问此页面。"
        extra={
          <Button type="primary" onClick={() => window.history.back()}>
            返回上一页
          </Button>
        }
      />
    )
  }

  // 权限验证通过，渲染子组件
  return <>{children}</>
}

export default RouteGuard
